<template>
	<v-container grid-list-md>
		<v-layout row wrap>
			<v-flex xs12>
				<filter-customer v-model="filter" @filter="onFilter()"></filter-customer>
			</v-flex>

			<v-flex xs12>
				<app-datatable :title="$t('Customer Datatable')" :endpoint="endpoint" :data="data" :headers="headers" :filter="filter" :per_page="per_page" @onEdit="editItem" @onDelete="deleteItem" @onView="viewItem">
					<template v-slot:[`item.image`]="{ item }">
						<app-thumbnail-placeholder v-model="item.image"></app-thumbnail-placeholder>
					</template>
					<template v-slot:[`item.code`]="{ item }">
						{{ item.code }} <br>
						<small v-if="item.is_thalias_employee" style="color: #c09a49; font-weight: bold;">Thalias Bee</small>
					</template>
					<template v-slot:[`item.phone`]="{ item }">
						{{ item.phone }}
						<span v-if="item.is_phone_verified">
							<v-icon small color="green">mdi-check</v-icon>
						</span>
					</template>
					<template v-slot:[`item.email`]="{ item }">
						{{ item.email }}
						<span v-if="item.is_email_verified">
							<v-icon small color="green">mdi-check</v-icon>
						</span>
					</template>
					<template v-slot:[`item.active`]="{ item }">
						<app-active-button v-model="item.active"></app-active-button>
					</template>
				</app-datatable>
			</v-flex>
		</v-layout>
		<app-create-fab-button @click="$inertia.visit($route('central.customers.create'))"></app-create-fab-button>

		<app-delete-dialog ref="deleteDialog" :endpoint="'central.customers.destroy'" :uuid="item.uuid"></app-delete-dialog>
	</v-container>
</template>
<script>
	import pickBy from "lodash/pickBy";
	export default {
		props: ["data", "per_page"],
		data() {
			return {
				filter: {},
				item: {},
			};
		},
		computed: {
			endpoint() {
				return this.$route("central.customers.index");
			},
			headers() {
				return [
					{
						text: this.$t("Action"),
						value: "actions",
						sortable: false,
						searchable: false,
						align: "left",
						width: 80,
					},
					{
						text: this.$t("Image"),
						value: "image",
						align: "start",
						sortable: false,
						width: 80,
					},
					{
						text: this.$t("Code"),
						value: "code",
						sortable: false,
						searchable: false,
						width: 70,
					},
					{
						text: this.$t("First Name"),
						value: "first_name",
						sortable: false,
						searchable: false,
						width: 180,
					},
					{
						text: this.$t("Last Name"),
						value: "last_name",
						sortable: false,
						searchable: false,
						width: 180,
					},
					{
						text: this.$t("Balance"),
						value: "balance",
						align: "start",
						sortable: false,
					},
					{
						text: this.$t("Membership"),
						value: "subscriptions_count",
						sortable: false,
					},
					{
						text: this.$t("Order Count"),
						value: "orders_count",
						sortable: false,
						width: 120,
					},
					{
						text: this.$t("Reservation Count"),
						value: "reservations_count",
						sortable: false,
						width: 150,
					},
					{
						text: this.$t("Gender"),
						value: "gender",
						sortable: false,
						searchable: false,
						width: 80,
						align: "left",
					},
					{
						text: this.$t("Date of Birth"),
						value: "formatted_date_of_birth",
						sortable: false,
						searchable: false,
						width: 80,
					},
					{
						text: this.$t("Phone Number"),
						value: "phone",
						sortable: false,
						searchable: false,
						width: 200,
						align: "left",
					},
					{
						text: this.$t("Email"),
						value: "email",
						sortable: false,
						searchable: false,
						width: 250,
						align: "left",
					},
					{
						text: this.$t("Telegram"),
						value: "telegram",
						sortable: false,
						searchable: false,
						align: "center",
						width: 150,
					},
					{
						text: this.$t("Address"),
						value: "address",
						sortable: false,
						searchable: false,
						width: 250,
					},
					// {
					// 	text: this.$t("label.last_connection"),
					// 	value: "last_connection",
					// 	sortable: false,
					// 	searchable: false,
					// 	align: "left",
					// 	width: 150,
					// },
					// {
					// 	text: this.$t("label.last_activity"),
					// 	value: "last_activity",
					// 	sortable: false,
					// 	searchable: false,
					// 	width: 150,
					// },
					{
						text: this.$t("label.creation_date"),
						value: "created_at",
						sortable: false,
						searchable: false,
						width: 250,
						align: "left",
					},
					{
						text: this.$t("Active"),
						value: "active",
						sortable: false,
						searchable: false,
						width: 150,
						align: "right",
					},
				];
			},
		},

		methods: {
			onFilter() {
				var filter = pickBy(this.filter);
				this.$inertia.get(
					this.endpoint,
					{ filter },
					{
						preserveState: true,
						preserveScroll: true,
					}
				);
			},
			editItem(item) {
				this.$inertia.get(this.$route("central.customers.edit", item.uuid));
			},

			viewItem(item) {
				this.$inertia.get(this.$route("central.customers.show", item.uuid));
			},

			deleteItem(item) {
				this.item = Object.assign({}, item);
				this.$refs.deleteDialog.open();
			},
		},
	};
</script>